const Content = () => {
    return (
        <div className="container mx-auto">
            <h1 className="text-center text-3xl mt-32">
                Mohon maaf...
            </h1>
            <p className="text-center text-3xl">
                Saat ini halaman masih dalam pengembangan 
            </p>
        </div>
    )
}

export default Content